import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { business, businessHours, navLinks, serviceAreas, tagline } from '../data/site';
import { ui } from '../data/ui';
import { useLanguage } from '../contexts/LanguageContext';
const socials = [{
  href: business.social.facebook,
  label: 'Facebook',
  Icon: FacebookIcon
}, {
  href: business.social.instagram,
  label: 'Instagram',
  Icon: InstagramIcon
}, {
  href: business.social.youtube,
  label: 'YouTube',
  Icon: YoutubeIcon
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="bg-navy-deep pb-16 text-navy-100 sm:pb-0" data-id="element-68" data-mp="3qfjighqnxfon">
      <div className="mx-auto max-w-7xl px-6 py-14" data-id="element-69" data-mp="29y5kubu3m50a">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.7fr_1fr_1fr]" data-id="element-70" data-mp="2ey9yzv7jannc">
          <div data-id="element-71" data-mp="2ezl0fodibjba">
            <div className="flex items-center gap-3" data-id="element-72" data-mp="2evxat0b6nh1u">
              <span className="rounded bg-white px-2 py-1.5" data-id="element-73" data-mp="3labovo69tsmo">
                <img src={business.logo} alt={`${business.name} logo`} className="h-9 w-auto object-contain" data-id="element-74" data-mp="3gapd7j63ckfz" />
              </span>
              <span className="font-display text-xl font-semibold text-white" data-id="element-75" data-mp="3q8wu620dr2hz">
                {business.name}
              </span>
            </div>
            <p className="mt-4 max-w-xs font-display italic text-gold" data-id="element-76" data-mp="81fltl5ky7yx">{t(tagline)}</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-navy-100/80" data-id="element-77" data-mp="335trjf5jnhj">
              {t({
              en: 'Family-owned painting, drywall, flooring and remodeling contractor serving Dallas-Fort Worth for over 10 years. Licensed and insured.',
              es: 'Contratista familiar de pintura, drywall, pisos y remodelación al servicio de Dallas-Fort Worth por más de 10 años. Con licencia y asegurados.'
            })}
            </p>
            <ul className="mt-5 flex items-center gap-3" data-id="element-78" data-mp="tvd0bu5d69g7">
              {socials.map(({
              href,
              label,
              Icon
            }) => <li key={label} data-id="element-79" data-mp="ytejef2si8ro">
                  <a href={href} target="_blank" rel="noreferrer" aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-navy-100 transition-colors duration-150 ease-out-expo hover:border-gold hover:text-gold" data-id="element-80" data-mp="yupnyh427kju">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="1hj4b2tb9aefd" />
                  </a>
                </li>)}
            </ul>
          </div>

          <nav aria-labelledby="footer-links" data-id="element-82" data-mp="1rilet56y6i8p">
            <h2 id="footer-links" className="text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-83" data-mp="1rid3viudxn05">
              {t(ui.quickLinks)}
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-84" data-mp="3tarquwbsdhnf">
              {navLinks.map(link => <li key={link.to} data-id="element-85" data-mp="2agokz95v8aeb">
                  <Link to={link.to} className="transition-colors duration-150 ease-out-expo hover:text-gold" data-id="element-86" data-mp="25of1aavcg6kh">
                    {t(link.label)}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-87" data-mp="2tdzkmuvet5ua">
            <h2 className="text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-88" data-mp="2tdpwzdxu7arr">
              {t(ui.contact)}
            </h2>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-89" data-mp="2pdpf1jbj4hfy">
              <li data-id="element-90" data-mp="2kd1f285boq9l">
                <a href={business.phoneHref} className="flex items-center gap-2.5 transition-colors duration-150 ease-out-expo hover:text-gold" data-id="element-91" data-mp="2kci8top1bqbe">
                  <PhoneIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-92" data-mp="18yeeuiig626c" />
                  {business.phoneDisplay}
                </a>
              </li>
              <li data-id="element-93" data-mp="2rvr8jib0yugx">
                <a href={business.whatsappHref} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 transition-colors duration-150 ease-out-expo hover:text-gold" data-id="element-94" data-mp="2rv7ptzdjw21u">
                  <WhatsAppIcon className="h-4 w-4 shrink-0 text-gold" data-id="element-95" data-mp="2it88f5ymivyd" />
                  WhatsApp {business.phoneDisplay}
                </a>
              </li>
              <li data-id="element-96" data-mp="3bl1morv4h7cx">
                <a href={business.emailHref} className="flex items-start gap-2.5 break-all transition-colors duration-150 ease-out-expo hover:text-gold" data-id="element-97" data-mp="3bki1n2a6e2uo">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-98" data-mp="31nn68s978ikm" />
                  {business.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-99" data-mp="1q5m60114txd3">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-100" data-mp="1v574kace43pa" />
                Dallas, Texas — Dallas-Fort Worth Metroplex
              </li>
            </ul>

            <h2 className="mt-7 text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-101" data-mp="1imv11rpfzj71">
              {t(ui.hours)}
            </h2>
            <ul className="mt-4 space-y-2 text-sm" data-id="element-102" data-mp="1wlkyj8g6bkvx">
              {businessHours.map(entry => <li key={entry.day.en} className="flex flex-col" data-id="element-103" data-mp="1rom56s4c3hys">
                  <span className="text-white/90" data-id="element-104" data-mp="13xp1g2mozqym">{t(entry.day)}</span>
                  <span className="text-navy-100/70" data-id="element-105" data-mp="13vvwqsvn3gt9">{t(entry.hours)}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-106" data-mp="1do1l7smong3p">
            <h2 className="text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-107" data-mp="1dote2vowazqa">
              {t(ui.serviceArea)}
            </h2>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-navy-100/80" data-id="element-108" data-mp="18v8fp2je43qk">
              {serviceAreas.map(city => <li key={city} data-id="element-109" data-mp="g95ubqfdpk84">{city}</li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-110" data-mp="2g9lz837cnal6">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-xs text-navy-100/70 md:flex-row md:items-center md:justify-between" data-id="element-111" data-mp="2g8svzc7ln37s">
          <p data-id="element-112" data-mp="2q1hxpfdcl2px">
            © {year} {business.name}.{' '}
            {t({
            en: 'All rights reserved. Licensed & insured general contractor. Estimates are free and carry no obligation; final pricing is confirmed after on-site inspection.',
            es: 'Todos los derechos reservados. Contratista con licencia y seguro. Los presupuestos son gratis y sin compromiso; el precio final se confirma tras la inspección en sitio.'
          })}
          </p>
          <ul className="flex shrink-0 items-center gap-5" data-id="element-113" data-mp="2bbajxcyac7vk">
            <li data-id="element-114" data-mp="2b9g0k32nwntl">
              <Link to="/privacy" className="hover:text-gold" data-id="element-115" data-mp="2b97qeixxbwm3">
                {t(ui.privacy)}
              </Link>
            </li>
            <li data-id="element-116" data-mp="3mpxzc9tqf2je">
              <Link to="/terms" className="hover:text-gold" data-id="element-117" data-mp="3mpefuoofo639">
                {t(ui.terms)}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}